import React, { useEffect } from "react";
import { useMixpanel } from "@taskpane/context";
import { Header } from "@taskpane/components";
import { withTransition } from "@taskpane/hoc";
import css from "./DifferentUserScreen.module.scss";

const DifferentUserScreen: React.FC = () => {
  const { trackEvent } = useMixpanel();

  const attrs = {
    container: {
      className: css.container,
    },
    content: {
      className: css.content,
    },
    image: {
      className: css.image,
      src: "/assets/maintenance.png",
      alt: "Different User",
    },
    textWrapper: {
      className: css.textWrapper,
    },
    title: {
      className: css.title,
    },
    description: {
      className: css.description,
    },
  };

  useEffect(() => {
    trackEvent("differentUserScreen.view");
  }, [trackEvent]);

  return (
    <div {...attrs.container}>
      <Header />
      <div {...attrs.content}>
        <img {...attrs.image} />
        <div {...attrs.textWrapper}>
          <span {...attrs.title}>Account Mismatch</span>
          <span {...attrs.description}>
            You’re signed into Outlook with a different Microsoft account. Please refresh or restart
            Outlook, then sign in with the correct account to continue.
          </span>
        </div>
      </div>
    </div>
  );
};

export default withTransition(DifferentUserScreen);
